/**
 * Query keys for the tenant/site domain (D4a). `settings` is a single resource —
 * the working window of the signed-in site, no filters.
 */
export const tenantQueryKeys = {
  all: ['tenant'] as const,
  settings: () => [...tenantQueryKeys.all, 'settings'] as const,
};